import React, { useState } from 'react';
import { Box } from '@mui/material';
import Habitsbody from "../components/Habitsbody"

const Habits = () => {
    return (
        <Box>
            <Habitsbody />

        </Box>
    );
};

export default Habits;
